<template>
  <v-layout class="d-flex flex-column" style="padding-left: 4px">
    <v-row class="py-2 align-center flex-wrap">
      <v-col xs2 cols="4" class="text-truncate text-subtitle" style="height: 45px;"
      >
        {{ definition.title }}
      </v-col>

      <v-col cols="1" class="text-center">
        <workflow-settings-card-type-color-picker
          :color="definition.color && definition.color.rgb"
          variant="events"
          @change="changeColor"
        ></workflow-settings-card-type-color-picker>
      </v-col>
    </v-row>

    <v-row class="mt-0 mb-2">
      <v-col class="pt-0 pb-0">
        <div
          v-if="!showDescription"
          class="show-hide-description text-light-blue expension-btn"
          @click="openDescription"
        >
          Show description
          <v-icon size="x-small" color="light-blue">chevron_right</v-icon>
        </div>

        <div
          v-else
          class="show-hide-description text-light-blue expension-btn"
          @click="closeDescription"
        >
          Hide description
          <v-icon size="x-small" color="light-blue">chevron_right</v-icon>
        </div>

        <v-expand-transition>
          <div v-show="showDescription" class="card rounded-lg my-2 mr-2">
            <textarea
              v-model="descriptionModel"
              rows="2"
              ref="textareaElement"
              @focus="computeHeight"
              @keydown.exact="computeHeight"
              @keydown.enter.exact.prevent="submitDescriptionChange"
              @keydown.alt.enter.exact.prevent="handleDescriptionAltEnter"
              @keydown.27.stop="cancelDescriptionChange"
              @cut="computeHeight"
              @paste="computeHeight"
              @drop="computeHeight"
              :disabled="$store.state.isWorkflowDisabled"
            ></textarea>

            <v-layout justify-end class="pa-1 d-flex align-center">
              <v-btn
                class="ma-0 mx-2 action-button"
                color="primary"
                :disabled="descriptionModel === definition.description"
                @click="cancelDescriptionChange"
                rounded="lg"
                size="small"
                variant="plain"
              >Cancel
              </v-btn>

              <v-btn
                class="ma-0 action-button"
                :disabled="descriptionModel === definition.description"
                @click="submitDescriptionChange"
                rounded="lg"
                size="small"
                variant="flat"
                color="primary"
              >Save
              </v-btn>
            </v-layout>
          </div>
        </v-expand-transition>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import WorkflowSettingsCardTypeColorPicker from '@/components/WorkflowSettingsCardTypeColorPicker'

export default {
  components: {
    WorkflowSettingsCardTypeColorPicker
  },

  props: {
    definition: Object,
    disabled: Boolean
  },

  data () {
    return {
      showDescription: false,
      descriptionModel: ''
    }
  },

  methods: {
    _emitUpdate (payload) {
      const {
        id,
        color: { red, green, blue },
        description
      } = this.definition

      const input = {
        color: { red, green, blue },
        description,
        ...payload
      }

      this.$emit('update-definition', id, input)
    },

    changeColor (color) {
      this._emitUpdate({ color })
    },

    computeHeight () {
      if (!this.$refs.textareaElement) {
        return
      }

      const { textareaElement } = this.$refs

      this.$nextTick(() => {
        setImmediate(() => {
          textareaElement.style.height = 'auto'
          textareaElement.style.height = `${textareaElement.scrollHeight}px`
        })
      })
    },

    openDescription () {
      this.descriptionModel = this.definition.description || ''
      this.showDescription = true

      setTimeout(() => {
        if (this.$refs.textareaElement) {
          this.$refs.textareaElement.focus()
        }
      }, 50)
    },

    closeDescription () {
      this.showDescription = false
    },

    handleDescriptionAltEnter (event) {
      const { textareaElement } = this.$refs
      const startPosition = textareaElement.selectionStart
      const endPosition = textareaElement.selectionEnd
      const result = [
        this.descriptionModel.slice(0, startPosition),
        '\n',
        this.descriptionModel.slice(endPosition)
      ].join('')

      // update textarea value
      this.descriptionModel = result

      // set cursor position
      this.$nextTick(() => {
        textareaElement.selectionEnd = endPosition + 1
      })
    },

    cancelDescriptionChange () {
      this.descriptionModel = this.definition.description || ''
      this.$refs.textareaElement.blur()
    },

    submitDescriptionChange () {
      this._emitUpdate({ description: this.descriptionModel })
    }
  }
}
</script>

<style scoped>
.show-hide-description {
  font-size: 13px;
  line-height: 14.3px;
}

textarea {
  width: 100%;
  resize: none;
  outline: none;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  min-height: 40px;
}

.action-button {
  border-radius: 6px !important;
  min-width: 60px;
}

.expension-btn {
  cursor: pointer;
}
</style>
